// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Paginator_pagination__2O2i2"};